// extracted by mini-css-extract-plugin
export var copyBtn = "rXGzrJMf";
export var codeContent = "wWPSs-7L";